// Common configurations related to Search scope.

// Highlight for hot keywords, normal for history keywords
export const HIGHLIGHT_TYPE = Object.freeze({
  HIGHLIGHT: 1,
  NORMAL: 0
});
